import { api } from 'app/config/apiConfig';
import { SizeCode, SizeCodeType } from '../model/types';

interface Params {
  warehouseId?: string | string[];
  square?: number;
  sizeCodeType?: SizeCodeType;
}

export const getSizeCodesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSizeCodes: build.query<SizeCode[], Params | void>({
      query: (args) => ({
        url: '/size-codes',
        params: args ? { ...args } : undefined,
      }),
    }),
  }),
});

export const { useGetSizeCodesQuery } = getSizeCodesApi;
